import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './SingleListSelectorPanel.scss';

const SingleListSelectorPanel = ({
  children,
  doubleWidth,
  extraClass,
}) => {
  const wrapperClass = classnames('single-list-selector__panel', {
    [extraClass]: extraClass,
    'double-width': doubleWidth,
  });

  return (
    <div className={wrapperClass}>
      {children}
    </div>
  );
};

SingleListSelectorPanel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  doubleWidth: PropTypes.bool,
  extraClass: PropTypes.string,
};

SingleListSelectorPanel.defaultProps = {
  doubleWidth: false,
  extraClass: '',
};

export default SingleListSelectorPanel;
